if (!customElements.get("quick-cart-drawer")) {
  class QuickCartDrawer extends HTMLElement {
    constructor() {
      super();
      /* Codice modificato da Planet Soluzioni */
      this._eventsController = null;
      this._triggerClickHandler = null;
      this._requestController = null;
      this._loadingTrigger = null;
      this._openTimeout = null;
    }

    connectedCallback() {
      this.init();
    }

    /* Codice modificato da Planet Soluzioni */
    disconnectedCallback() {
      this._eventsController?.abort();
      this._eventsController = null;

      if (this._triggerClickHandler) {
        document.removeEventListener("click", this._triggerClickHandler);
        this._triggerClickHandler = null;
      }

      this._requestController?.abort();
      this._requestController = null;
      this._loadingTrigger?.classList.remove("is--loading");
      this._loadingTrigger = null;
      clearTimeout(this._openTimeout);
      this._openTimeout = null;

      this.sliderInstance?.destroy(true, true);
      this.sliderInstance = null;

      this.resumeSourceSliders();
      if (this.toggleState) this.close();
    }

    init() {
      /* Codice modificato da Planet Soluzioni */
      if (!this.isConnected) return;
      this.initTriggers();
      if (this._eventsController) return;

      this._eventsController = new AbortController();
      const { signal } = this._eventsController;
      this.toggleState = false;

      /* Codice modificato da Planet Soluzioni */
      if (Shopify.designMode) {
        this.parentElement?.addEventListener(
          "shopify:section:select", () => this.open(), { signal }
        );
        this.parentElement?.addEventListener(
          "shopify:section:deselect", () => this.close(), { signal }
        );
      }

      /* Codice modificato da Planet Soluzioni */
      this.querySelector(".button--close").addEventListener(
        "click",
        this.close.bind(this),
        { signal }
      );
      this.querySelector(
        ".quick-cart-drawer__backdrop"
      ).addEventListener("click", this.close.bind(this), { signal });

      /* Codice modificato da Planet Soluzioni */
      this.querySelector(".quick-cart-drawer__blocks").addEventListener("keydown", e => {
        if (e.key === "Escape" && this.toggleState) {
          this.close();
        }

        if (this.toggleState && e.key === "Tab") {
          const focusableElements = this.querySelectorAll(
            'button, [href], input, select, label, textarea, [tabindex]:not([tabindex="-1"])'
          );
          const firstFocusableElement = focusableElements[0];
          const lastFocusableElement =
            focusableElements[focusableElements.length - 1];

          if (!firstFocusableElement) return;

          if (e.shiftKey) {
            if (document.activeElement === firstFocusableElement) {
              e.preventDefault();
              lastFocusableElement.focus();
            }
          } else {
            if (document.activeElement === lastFocusableElement) {
              e.preventDefault();
              firstFocusableElement.focus();
            }
          }
        }
      }, { signal });
    }

    /* Codice modificato da Planet Soluzioni */
    initTriggers() {
      if (!this.isConnected || this._triggerClickHandler) return;

      this._triggerClickHandler = event => {
        if (!(event.target instanceof Element)) return;
        const trigger = event.target.closest(".quick-cart-drawer__trigger");
        if (!trigger || !this.isConnected) return;

        event.preventDefault();
        this.fetchProductForQuickCartDrawer(event);
      };

      document.addEventListener("click", this._triggerClickHandler);
    }

    /* Codice modificato da Planet Soluzioni */
    async fetchProductForQuickCartDrawer(event) {
      if (!(event.target instanceof Element) || !this.isConnected) return;

      const button = event.target.closest(".quick-cart-drawer__trigger");
      const trigger = button?.closest("[data-product-url]");
      if (!trigger) return;

      const isRecommendations = button.classList.contains(
        "quick-cart-drawer__trigger--recommendations"
      );
      const sourceProductCard = button.closest("product-card");
      if (!isRecommendations && !sourceProductCard) return;

      // Capture the selection before the asynchronous request.
      const productOptions = !isRecommendations
        ? Array.from(
            sourceProductCard.querySelectorAll(
              'input[type="radio"]:checked, select'
            ),
            option => ({ name: option.name, value: option.value })
          )
        : [];
      const sourceVariantId = sourceProductCard?.querySelector(
        'input[name="id"]'
      )?.value;

      // Only the latest request may update and open this drawer.
      this._requestController?.abort();
      this._loadingTrigger?.classList.remove("is--loading");
      clearTimeout(this._openTimeout);
      this._openTimeout = null;

      this.resumeSourceSliders();
      const controller = new AbortController();
      this._requestController = controller;
      this._loadingTrigger = trigger;
      trigger.classList.add("is--loading");

      const sourceSlider = button.closest("card-product-slider");
      sourceSlider?.slider?.autoplay?.stop();
      sourceSlider?.classList.add("product--open-on-quick-cart");

      let productReady = false;

      try {
        let fetchPrefix = "";
        if (window.Shopify.routes.root.includes(`/${window.Shopify.locale}/`)) {
          fetchPrefix = `/${window.Shopify.locale}`;
        }

        const productCardResponse = await fetch(
          `${fetchPrefix}${trigger.dataset.productUrl}/?view=quick-cart`,
          { signal: controller.signal }
        );
        if (!productCardResponse.ok) {
          throw new Error(`Quick cart request failed: ${productCardResponse.status}`);
        }

        const productCardHTML = await productCardResponse.text();
        if (controller.signal.aborted || !this.isConnected) return;

        const productContainer = document.createElement("div");
        productContainer.insertAdjacentHTML("beforeend", productCardHTML);
        const productContent = productContainer.querySelector(".quick-cart-product");
        if (!productContent) throw new Error("Quick cart product not found.");

        const drawerMain = this.querySelector(".quick-cart-drawer__main");

        // Release the previous slider before removing its elements.
        this.sliderInstance?.destroy(true, true);
        this.sliderInstance = null;
        drawerMain.replaceChildren(productContent);

        const sliderElement = this.querySelector(".quick-cart-drawer__media-swiper");
        if (sliderElement) {
          this.sliderInstance = new Swiper(sliderElement, {
            slidesPerView: 1.25,
            spaceBetween: 8,
            freeMode: {
              enabled: true
            },
            breakpoints: {
              750: {
                slidesPerView: 2
              }
            }
          });
        }

        const drawerProductCard = drawerMain.querySelector("product-card");
        if (!drawerProductCard) throw new Error("Quick cart product card not found.");

        if (!isRecommendations) {
          const optionInputs = Array.from(
            drawerProductCard.querySelectorAll('input[type="radio"]')
          );

          productOptions.forEach(productOption => {
            const selectedInput = optionInputs.find(
              input => input.name === productOption.name &&
                input.value === productOption.value
            );
            if (!selectedInput) return;

            optionInputs
              .filter(input => input.name === productOption.name)
              .forEach(input => {
                const isSelected = input === selectedInput;
                input.checked = isSelected;
                input.toggleAttribute("checked", isSelected);
                input.closest("li")?.classList.toggle("checked", isSelected);
              });

            const selectedLabel = selectedInput.closest("fieldset")?.querySelector(
              "legend [data-selected-variant]"
            );
            if (selectedLabel) selectedLabel.textContent = productOption.value;
          });

          // Refresh state once; never re-register product-card listeners.
          drawerProductCard.updateVariantStatuses();
          const { currentVariantId } =
            drawerProductCard.findCurrentVariantFromOptionRadioInputs();
          const variantInput = drawerProductCard.querySelector('input[name="id"]');
          if (variantInput && (currentVariantId || sourceVariantId)) {
            variantInput.value = currentVariantId || sourceVariantId;
          }

          if (!drawerProductCard.querySelector(".product-card__media")?.dataset.updateMedia) {
            drawerProductCard.updateMediaForVariant(currentVariantId);
          }
          drawerProductCard.setCartButtonState();
        }

        drawerMain.querySelectorAll(".variant-option-radio-input").forEach(input => {
          input.addEventListener("change", event => {
            const selectedLabel = event.target.closest("fieldset")?.querySelector(
              "legend [data-selected-variant]"
            );
            if (selectedLabel) selectedLabel.textContent = event.target.value;

            const selectedVariantId = drawerProductCard.querySelector(
              ".product-card__add-to-cart--form input[name='id']"
            )?.value;
            const featuredMedia = drawerProductCard.variantsObj?.find(
              variant => variant.id == selectedVariantId
            )?.featured_media;
            if (featuredMedia) this.setActiveMedia(featuredMedia.id);
          });
        });

        // Keep the existing opening delay, but make it cancellable.
        this._openTimeout = setTimeout(() => {
          this._openTimeout = null;
          if (this.isConnected && !controller.signal.aborted) this.open();
        }, 500);
        productReady = true;
      } catch (error) {
        if (error.name !== "AbortError") {
          console.error("Quick cart could not be loaded:", error);
        }
      } finally {
        // On failure, do not synchronize or open stale product content.
        if (this._requestController === controller) {
          this._requestController = null;
          trigger.classList.remove("is--loading");
          this._loadingTrigger = null;

          if (!productReady && !this.toggleState) {
            sourceSlider?.slider?.autoplay?.start();
            sourceSlider?.classList.remove("product--open-on-quick-cart");
          }
        }
      }
    }

    setActiveMedia(id) {
      const mediaFound = Array.from(
        this.querySelectorAll("[data-media-id]")
      ).find(media => Number(media.dataset.mediaId) === id);
      /* Codice modificato da Planet Soluzioni */
      if (mediaFound && this.sliderInstance) {
        this.sliderInstance.slideTo(Number(mediaFound.dataset.index));
      }
    }

    /** Drawer coreß functions */
    toggle() {
      if (!this.toggleState) {
        this.open();
      } else {
        this.close();
      }
    }

    open() {
      /* Codice modificato da Planet Soluzioni */
      if (!this.isConnected) return;
      this.toggleState = true;
      document.querySelector("body").classList.add("overflow-hidden");
      /* Codice modificato da Planet Soluzioni */
      const quickCartDrawer = this.querySelector(".quick-cart-drawer__blocks");
      const closeButton = quickCartDrawer.querySelector(".button--close");
      quickCartDrawer.setAttribute("tabindex", "0");
      closeButton.setAttribute("tabindex", "0");
      this.classList.add("is--open");
      this.opened();

      const firstFocusableElement = this.querySelector(
        'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])'
      );
      if (firstFocusableElement) {
        firstFocusableElement.focus();
      }
    }

    close() {
      /* Codice modificato da Planet Soluzioni */
      clearTimeout(this._openTimeout);
      this._openTimeout = null;
      this._requestController?.abort();
      this._requestController = null;
      this._loadingTrigger?.classList.remove("is--loading");
      this._loadingTrigger = null;
      this.toggleState = false;

      const shopTheLookDrawer = document.querySelector("shop-the-look-drawer");

      if(shopTheLookDrawer && !shopTheLookDrawer.classList.contains("is--open")) {
        document
          .querySelector("body")
          .classList.remove("overflow-hidden");
      }
      if(!shopTheLookDrawer) {
        document
          .querySelector("body")
          .classList.remove("overflow-hidden");
      }
      this.classList.remove("is--open");
      this.closed();
      this.toggleAriaExpanded();

      /* Codice modificato da Planet Soluzioni */
      this.resumeSourceSliders();
    }

    /* Codice modificato da Planet Soluzioni */
    resumeSourceSliders() {
      document.querySelectorAll(
        "card-product-slider.product--open-on-quick-cart"
      ).forEach(slider => {
        slider.slider?.autoplay?.start();
        slider.classList.remove("product--open-on-quick-cart");
      });
    }

    toggleAriaExpanded(event) {
      if (event) {
        if (event.target.closest("button"))
          event.target
            .closest("button")
            .setAttribute("aria-expanded", true);
        this.querySelector(".button--close").setAttribute(
          "aria-expanded",
          true
        );
      } else {
        document
          .querySelectorAll('[aria-controls="quick-cart-drawer"]')
          .forEach(button => {
            button.setAttribute("aria-expanded", false);
          });
      }
    }

    opened() {
      const openedEvent = new Event("opened", { bubbles: true });
      this.dispatchEvent(openedEvent);
    }

    closed() {
      const closedEvent = new Event("closed", { bubbles: true });
      this.dispatchEvent(closedEvent);
    }
  }

  customElements.define("quick-cart-drawer", QuickCartDrawer);
}
